import { render, staticRenderFns } from "./SystemPreferences.vue?vue&type=template&id=1d0a22e9&scoped=true&"
import script from "./SystemPreferences.vue?vue&type=script&lang=js&"
export * from "./SystemPreferences.vue?vue&type=script&lang=js&"
import style0 from "./SystemPreferences.vue?vue&type=style&index=0&id=1d0a22e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0a22e9",
  null
  
)

export default component.exports